import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { CommonIconsComponent } from '@shared/icon-components/common-icons.component';
import { common_icons_ids } from '@shared/strings/common.strings';

@Component({
  selector: 'app-loading-toaster',
  templateUrl: './loading-toaster.component.html',
  styleUrls: ['./loading-toaster.component.scss'],
  imports: [ToastModule, ProgressBarModule, CommonIconsComponent],
})
export class LoadingToasterComponent {
  protected readonly common_icons_ids = common_icons_ids;
}
